import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import DatePicker from "react-datepicker";

function EditManualPayment() {
  const [amount, setAmount] = useState();
  const [date, setDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const location = useLocation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/manualPayments/${location.state.id}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setAmount(response.data.manualPayment.amount);
      setDate(new Date(response.data.manualPayment.created_at));
      setIsLoading(false);
    }
    fetch();
  }, [state.token, location.state.id]);

  const handleAmountChange = (evt) => {
    setAmount(evt.target.value);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/manualPayments/web/${location.state.id}`,
        data: {
          amount: amount,
          date: date,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate(`/manual-payments/${location.state.rid}`);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="edit-manual-payment">
        <Col>
          <h4>Editar pago en efectivo</h4>
        </Col>
        <Col className="edit-manual-payment-form">
          <Form>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Cantidad"
                onChange={handleAmountChange}
                value={amount}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Fecha</Form.Label>
              <DatePicker selected={date} onChange={(date) => setDate(date)} />
            </Form.Group>
            <Form.Group>
              <Button variant="info" onClick={handleSubmit}>
                Guardar
              </Button>
              <Button
                variant="danger"
                onClick={() =>
                  navigate(`/manual-payments/${location.state.rid}`)
                }
              >
                Cancelar
              </Button>
            </Form.Group>
          </Form>
        </Col>
      </Col>
    );
  }
}

export default EditManualPayment;
